export interface IOptionDocumentType {
  value: string;
  text: string;
}
export interface IGroupDocumentType {
  label: string;
  options: IOptionDocumentType[];
}

// Constantes para tipos de búsqueda
export const SEARCH_TYPES = {
  CREW: {
    DNI: {
      value: "DNI",
      textKey: "label.documentType.dni",
    },
  },
  FLEET: {
    INTERNAL_NUMBER: {
      value: "label.internal.number",
      textKey: "label.internal.number",
    },
    PLATE: {
      value: "label.plate",
      textKey: "label.plate",
    },
  },
};

// Helper para crear opciones traducidas
export const createSearchOption = (
  type: { value: string; textKey: string },
  translate: (key: string) => any
): IOptionDocumentType => ({
  value: type.value === "DNI" ? type.value : (translate(type.value) as string),
  text: translate(type.textKey) as string,
});
